/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../clients/axios.ts";
import type { RequestConfig, ResponseErrorConfig } from "../../../clients/axios.ts";
import type { GetApiAuthorsQueryResponse, GetApiAuthorsQueryParams, GetApiAuthors400, GetApiAuthors401, GetApiAuthors403, GetApiAuthors500 } from "../../types/GetApiAuthors.ts";
import { getApiAuthorsQueryResponseSchema } from "../../zod/AuthorSchemas/getApiAuthorsSchema.ts";

function getGetApiAuthorsUrl() {
  const res = { method: 'GET', url: `/api/authors` as const }  
  return res
}

/**
 * @summary Метод получения списка авторов.
 * {@link /api/authors}
 */
export async function getApiAuthors({ params }: { params?: GetApiAuthorsQueryParams }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetApiAuthorsQueryResponse, ResponseErrorConfig<GetApiAuthors400 | GetApiAuthors401 | GetApiAuthors403 | GetApiAuthors500>, unknown>({ method : "GET", url : getGetApiAuthorsUrl().url.toString(), params, ... requestConfig })  
  return getApiAuthorsQueryResponseSchema.parse(res.data)
}